/* My Try-On Gallery page（ADR 0003 + ADR 0004）：jobs 网格 + source photo + 结果弹窗 + recently viewed。
   数据：jobs 走 try-on-core；source photo 走 /apps/mediacreation/source-photo；
   加购/cap/规格走 try-on-commerce。 */
(function () {
  function init(root) {
    var loggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var loginUrl = root.getAttribute('data-login-url') || '/account/login';
    var shopAllUrl = root.getAttribute('data-shop-all-url') || '/collections/all';
    /* x-modal 打开时会被主题搬到 document.body：弹窗内元素必须回退到 document 查询 */
    var $ = function (sel) { return root.querySelector(sel) || document.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var gate = $('[data-mtg="gate"]');
    var loginLink = $('[data-mtg="loginLink"]');
    var loading = $('[data-mtg="loading"]');
    var errorBox = $('[data-mtg="error"]');
    var sourceCard = $('[data-mtg="sourceCard"]');
    var librarySection = $('[data-mtg="librarySection"]');
    var recentSection = $('[data-mtg="recentSection"]');
    var grid = $('[data-mtg="grid"]');
    var empty = $('[data-mtg="empty"]');
    var toastTimer = null;
    var client = window.JalizaTryOnCore ? window.JalizaTryOnCore.createClient() : null;
    var commerce = window.JalizaTryOnCommerce || null;
    var sectionId = root.getAttribute('data-section-id') || '';
    var capDialog = commerce ? commerce.createCapDialog({
      modalId: 'MtgCap-' + sectionId,
      toast: function (message) { showToast(message); },
      onAdd: function (variantId, btn) {
        return commerce.addVariant(variantId, btn, { toast: showToast, source: 'my-try-on-gallery' });
      }
    }) : null;
    var activeFilter = 'all';
    var jobAvailability = {};
    var params = new URLSearchParams(window.location.search || '');
    var highlightJob = params.get('job') || '';
    var pendingPhotoFile = null;
    var pendingConfirm = null;

    function showToast(msg, ms) {
      var t = $('[data-mtg="toast"]');
      if (!t) return;
      t.textContent = msg;
      t.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('show'); }, ms || 3000);
    }
    function isOpen(d) { return !!(d && d.hasAttribute('open')); }
    function resolveDlg(d) {
      if (d && d.tagName === 'X-MODAL') return d;
      if (d && d.closest) { var m = d.closest('x-modal'); if (m) return m; }
      /* anchor 已被搬走时：退回当前打开的 gallery 弹窗 */
      return document.querySelector('.my-try-on-gallery-scope.x-modal[open]');
    }
    function showDlg(d) { d = resolveDlg(d); if (d && d.show) d.show(); }
    function hideDlg(d) {
      d = resolveDlg(d);
      if (d && d.hide) d.hide();
      /* 兜底：主题 hideTransition 依赖 overlay transitionend；若动画事件丢失
         body 会残留 has-modal-open 导致页面无法滚动，600ms 后强制解锁 */
      setTimeout(function () {
        var stuck = document.querySelector('.my-try-on-gallery-scope.x-modal[open]');
        if (!stuck && document.body.classList.contains('has-modal-open')) {
          document.body.classList.remove('has-modal-open', 'has-modal-opening');
        }
      }, 600);
    }
    function statusOf(job) { return String(job.status || 'processing').toLowerCase(); }
    function isProcessing(job) { var s = statusOf(job); return s === 'pending' || s === 'processing' || s === 'queued' || s === 'running' || s === 'ready'; }
    function isFailed(job) { var s = statusOf(job); return s === 'failed' || s === 'cancelled'; }
    function fmtDate(iso) {
      if (!iso) return '';
      try { return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
      catch (e) { return ''; }
    }
    function relDate(ts) {
      if (!ts) return 'Recently created';
      var mins = Math.max(0, Math.floor((Date.now() - Number(new Date(ts))) / 60000));
      if (mins < 2) return 'Just now';
      if (mins < 60) return mins + ' minutes ago';
      var h = Math.floor(mins / 60);
      if (h < 24) return h + ' hour' + (h === 1 ? '' : 's') + ' ago';
      var d = Math.floor(h / 24);
      return d + ' day' + (d === 1 ? '' : 's') + ' ago';
    }
    function jobLabel(job) {
      var bits = [];
      if (job.color) bits.push(job.color);
      if (job.length) bits.push(job.length + '″');
      return bits.join(' · ') || 'Virtual Try-On';
    }
    function matches(job) {
      if (activeFilter === 'all') return true;
      if (activeFilter === 'ready') return statusOf(job) === 'done';
      if (activeFilter === 'processing') return isProcessing(job);
      return true;
    }
    /* 最新在前：按 createdAt 倒序；缺时间戳的沉底、保持原相对顺序 */
    function sortNewestFirst(list) {
      return list.slice().sort(function (a, b) {
        var ta = a && a.createdAt ? Number(new Date(a.createdAt)) : 0;
        var tb = b && b.createdAt ? Number(new Date(b.createdAt)) : 0;
        if (!isFinite(ta)) ta = 0;
        if (!isFinite(tb)) tb = 0;
        return tb - ta;
      });
    }

    /* ---- source photo 双槽位（front/side，不限次数） ---- */
    var gallerySlots = { front: '', side: '' };
    var pendingSlot = 'front';
    function slotLabel(slot) { return slot === 'side' ? 'Side view' : 'Front view'; }
    function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function renderGallerySlots() {
      var holder = $('[data-mtg="gallerySourceSlots"]');
      if (!holder) return;
      if (sourceCard) sourceCard.hidden = false;
      holder.innerHTML = ['front', 'side'].map(function (slot) {
        var url = gallerySlots[slot];
        var label = slotLabel(slot);
        var desc = slot === 'front' ? 'Best for seeing the hairline, part and face framing.' : 'Best for seeing length, volume and profile.';
        if (url) {
          return '<article class="gallery-source-slot"><figure>' +
            '<img data-mtg-source-image data-src="' + escAttr(url) + '" loading="lazy" decoding="async" fetchpriority="low" alt="Your ' + label.toLowerCase() + ' camera photo" />' +
            '</figure><div class="source-slot-body">' +
            '<h3>' + label + '</h3><p>' + desc + '</p>' +
            '<button class="source-photo-delete" type="button" data-delete-source-slot="' + slot + '" aria-label="Delete ' + label.toLowerCase() + ' photo">Delete photo</button>' +
            '</div></article>';
        }
        return '<article class="gallery-source-slot empty"><figure class="source-photo-empty-figure" tabindex="0" role="button" aria-label="Upload ' + label.toLowerCase() + ' photo" data-add-source-slot="' + slot + '">' +
          '<div class="source-photo-placeholder"><i aria-hidden="true">+</i><span>' + label + '</span></div>' +
          '</figure><div class="source-slot-body">' +
          '<h3>' + label + '</h3><p>' + desc + '</p>' +
          '<button class="source-photo-add" type="button" data-add-source-slot="' + slot + '">Upload photo</button></div></article>';
      }).join('');
      holder.querySelectorAll('[data-mtg-source-image]').forEach(function (img) {
        bindImageFallback(img, [{ url: img.getAttribute('data-src'), retry: true }], { host: img.closest('figure') });
      });
      holder.querySelectorAll('[data-delete-source-slot]').forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          ev.stopPropagation();
          deleteGallerySlot(btn.getAttribute('data-delete-source-slot'));
        });
      });
      holder.querySelectorAll('[data-add-source-slot]').forEach(function (btn) {
        /* figure 占位大、按钮在下方：两者都可点上传（下方按钮冒泡时去重一次） */
        if (btn.hasAttribute('data-mtg-upload-bound')) return;
        btn.setAttribute('data-mtg-upload-bound', '1');
        if (btn.tagName === 'FIGURE') btn.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); btn.click(); }
        });
        btn.addEventListener('click', function (ev) {
          if (ev && ev.__mtgUploadHandled) return;
          if (ev) ev.__mtgUploadHandled = true;
          beginGalleryUpload(btn.getAttribute('data-add-source-slot'));
        });
      });
    }
    function syncGallerySlots(photos) {
      gallerySlots = { front: '', side: '' };
      (photos || []).forEach(function (ph) {
        if (ph && (ph.slot === 'front' || ph.slot === 'side') && ph.url) gallerySlots[ph.slot] = ph.url;
      });
      renderGallerySlots();
    }
    function loadSource() {
      return client.listSourcePhotos().then(function (photos) {
        syncGallerySlots(photos);
        return photos;
      }).catch(function () { renderGallerySlots(); return []; });
    }
    function deleteGallerySlot(slot) {
      client.deleteSourcePhoto(slot).then(function () {
        gallerySlots[slot] = '';
        renderGallerySlots();
        showToast(slotLabel(slot) + ' photo deleted.');
      }).catch(function () { showToast('Delete failed, please retry.'); });
    }
    function stashReturnUrl() {
      try { sessionStorage.setItem('jaliza_return_url', window.location.pathname + window.location.search); } catch (e) {}
    }
    function requireLogin() {
      if (loggedIn) return true;
      stashReturnUrl();
      showToast('Log in to upload your photo and use Virtual Try-On.');
      if (loginUrl) window.location.href = loginUrl;
      return false;
    }
    function beginGalleryUpload(slot) {
      if (!requireLogin()) return;
      pendingSlot = slot === 'side' ? 'side' : 'front';
      var inp = $('[data-mtg="sourcePhotoInput"]');
      if (inp) inp.click();
    }
    function uploadGalleryFile(file) {
      if (!requireLogin()) return;
      pendingPhotoFile = file;
      var prev = $('[data-mtg="pendingSourcePreview"]');
      if (prev) {
        if (prev.src && prev.src.indexOf('blob:') === 0) URL.revokeObjectURL(prev.src);
        prev.src = URL.createObjectURL(file);
      }
      var lab = $('[data-mtg="uploadSlotLabel"]');
      if (lab) lab.textContent = (pendingSlot === 'side' ? 'SIDE' : 'FRONT') + ' VIEW';
      var consent = $('[data-mtg="photoConsent"]');
      if (consent) consent.checked = false;
      var useBtn = $('[data-mtg="useSelectedPhoto"]');
      if (useBtn) useBtn.disabled = true;
      var dlg = $('[data-mtg="closeUploadReview"]');
      showDlg(dlg ? dlg.closest('x-modal') : null);
    }

    /* ---- jobs grid ---- */
    function productName(job) {
      /* 后端已存 productTitle/styleTitle：优先用；老数据回退 handle 转标题 */
      if (job && job.productTitle) return String(job.productTitle);
      if (job && job.styleTitle) return String(job.styleTitle);
      if (job && job.productHandle) {
        var pretty = String(job.productHandle).replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
        if (pretty) return pretty.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      }
      return jobLabel(job) || 'Virtual Try-On';
    }
    function variantOf(job) {
      var v = job && job.variantId != null ? String(job.variantId).trim() : '';
      return /^\d+$/.test(v) ? v : '';
    }
    function jobCardBuyButton(job) {
      if (!grid || !job) return null;
      var cardEl = grid.querySelector('[data-entry-id="' + String(job.id).replace(/"/g, '') + '"]');
      return cardEl ? cardEl.querySelector('.card-cart') : null;
    }

    function refreshJobBuyState(job, btn, opts) {
      if (!commerce || !job || !btn) return;
      opts = opts || {};
      var key = String(job.id || job.variantId || '');
      if (!key) return;
      if (!btn.dataset.buyLabel) btn.dataset.buyLabel = btn.textContent;
      var check = opts.fresh ? null : jobAvailability[key];
      if (!check) {
        check = commerce.resolveJobAdd(job, {
          kind: job.kind || job.productType || '',
          productType: job.productType || '',
          fresh: opts.fresh === true
        });
        jobAvailability[key] = check;
      }
      check.then(function (action) {
        var unavailable = action.mode === 'sold_out' || action.mode === 'unavailable';
        btn.disabled = unavailable;
        btn.setAttribute('aria-disabled', String(unavailable));
        btn.classList.toggle('is-unavailable', unavailable);
        if (unavailable) {
          btn.textContent = action.mode === 'sold_out' ? 'SOLD OUT' : 'UNAVAILABLE';
          return;
        }
        btn.textContent = btn.dataset.buyLabel;
      }).catch(function () { delete jobAvailability[key]; });
    }

    /* Live resolve: wig asks for an available cap when needed; feather adds the exact material variant. */
    function handleJobBuy(job, btn) {
      if (!job) return;
      if (!commerce) { showToast('Add to cart unavailable.'); return; }
      var kind = job.kind || job.productType || '';
      if (btn) btn.disabled = true;
      commerce.resolveJobAdd(job, { kind: kind, productType: kind, fresh: true }).then(function (action) {
        var cacheKey = String(job.id || job.variantId || '');
        if (cacheKey) jobAvailability[cacheKey] = Promise.resolve(action);
        if (btn) btn.disabled = false;
        var cardBtn = jobCardBuyButton(job);
        if (cardBtn && cardBtn !== btn) refreshJobBuyState(job, cardBtn);
        if (action.mode === 'direct') {
          return commerce.addVariant(action.variantId, btn, {
            toast: showToast,
            source: 'my-try-on-gallery',
            successMessage: 'Added to cart.'
          });
        }
        if (action.mode === 'cap') {
          if (!capDialog) { showToast('Add to cart unavailable.'); return; }
          capDialog.open({
            image: job.skuThumbUrl || job.skuImageUrl || job.resultUrl,
            title: productName(job),
            priceText: job.price != null ? 'Starting at ' + commerce.money(job.price, window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD') : '',
            candidates: action.candidates,
            product: action.product,
            anchor: action.anchor
          });
          return;
        }
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = action.mode === 'sold_out' ? 'SOLD OUT' : 'UNAVAILABLE';
        }
        if (action.mode === 'sold_out') { showToast('This look is sold out.'); return; }
        if (job.productHandle) {
          window.location.href = '/products/' + encodeURIComponent(job.productHandle) + '?tryon_job=' + encodeURIComponent(job.id);
          return;
        }
        showToast('Open the product page to shop this look.');
      }).catch(function () { if (btn) btn.disabled = false; });
    }
    /* 产品页链接：有 variant 直达 ?variant=，否则产品页（带试戴上下文），无 handle 回 shopAll */
    function productUrlForJob(job) {
      if (job && job.productHandle) {
        var base = '/products/' + encodeURIComponent(job.productHandle);
        var vid = variantOf(job);
        if (vid) return base + '?variant=' + encodeURIComponent(vid);
        return base + '?tryon_job=' + encodeURIComponent(job.id);
      }
      return shopAllUrl;
    }
    /* 结果图优先用 thumb；thumb 缺失/404 时回退原图，再回退 SKU 图。
       弱网下单次请求失败会自动重试，最终失败也只显示占位，不留下浏览器破图图标。 */
    function imageSourcesFor(job, includeResult) {
      var out = [];
      var seen = {};
      function add(url, retry) {
        url = String(url == null ? '' : url).trim();
        if (!url || seen[url]) return;
        seen[url] = true;
        out.push({ url: url, retry: retry !== false });
      }
      if (includeResult) {
        add(job && job.resultThumbUrl, false);
        add(job && job.resultUrl, true);
        return out;
      }
      add(job && job.skuThumbUrl, false);
      add(job && job.skuImageUrl, true);
      return out;
    }
    function bindImageFallback(img, sources, opts) {
      if (!img || !img.addEventListener) return;
      opts = opts || {};
      var host = opts.host || img.parentNode;
      var list = (sources || []).filter(function (src) { return src && src.url; });
      var index = 0;
      var retried = {};
      var done = false;
      function finish(ok) {
        if (done) return;
        done = true;
        img.classList.remove('is-image-loading');
        if (ok) {
          img.style.visibility = '';
          img.classList.remove('is-image-failed');
          if (host && host.classList) host.classList.remove('has-image-failure');
          return;
        }
        img.classList.add('is-image-failed');
        img.style.visibility = 'hidden';
        img.alt = '';
        if (host && host.classList) host.classList.add('has-image-failure');
        if (opts.onFinalError) { try { opts.onFinalError(); } catch (e) {} }
      }
      function attempt() {
        if (done) return;
        var item = list[index];
        if (!item) { finish(false); return; }
        img.classList.add('is-image-loading');
        img.src = item.url;
      }
      img.addEventListener('load', function () {
        if (img.naturalWidth > 0) finish(true);
      });
      img.addEventListener('error', function () {
        if (done) return;
        var item = list[index];
        if (item && item.retry && !retried[item.url]) {
          retried[item.url] = true;
          setTimeout(function () {
            if (done) return;
            img.removeAttribute('src');
            img.src = item.url;
          }, 600);
          return;
        }
        index += 1;
        if (index < list.length) attempt();
        else finish(false);
      });
      attempt();
    }
    var imageRefreshAttempts = 0;
    function refreshImageJobsOnce() {
      if (imageRefreshAttempts >= 2 || !client || typeof client.refreshJobs !== 'function') return false;
      imageRefreshAttempts += 1;
      try {
        var ids = client.list().map(function (job) { return job && job.id; }).filter(Boolean);
        client.refreshJobs(ids).catch(function () {});
      } catch (e) {}
      return true;
    }
    function productTitle(job) {
      var base = jobLabel(job);
      if (job && job.sourceSlot && job.sourceSlot !== 'front') base += ' · ' + job.sourceSlot;
      return base;
    }
    function card(job, priority) {
      var s = statusOf(job);
      var processing = isProcessing(job);
      var el = document.createElement('article');
      el.className = 'try-on-card' + (processing ? ' processing' : '') +
        (highlightJob && job.id === highlightJob ? ' is-highlight' : '');
      el.setAttribute('data-entry-id', job.id);
      var fig = document.createElement('figure');
      var openBtn = document.createElement('button');
      openBtn.type = 'button';
      openBtn.setAttribute('data-open-entry', job.id);
      if (processing) openBtn.disabled = true;
      openBtn.setAttribute('aria-label', processing ? 'Try-On is processing' : 'Enlarge ' + productName(job) + ' Try-On');
      var img = document.createElement('img');
      img.alt = productName(job) + ' AI Try-On preview';
      img.decoding = 'async';
      img.width = 400; img.height = 500;
      img.loading = (priority === 'high' || priority === 'auto') ? 'eager' : 'lazy';
      img.fetchPriority = priority || 'low';
      bindImageFallback(img, imageSourcesFor(job, s === 'done'), {
        host: fig,
        onFinalError: s === 'done' ? refreshImageJobsOnce : null
      });
      openBtn.appendChild(img);
      fig.appendChild(openBtn);
      var chip = document.createElement('span');
      chip.className = 'ai-chip';
      chip.textContent = 'AI TRY-ON';
      fig.appendChild(chip);
      if (s === 'done') {
        var del = document.createElement('button');
        del.className = 'delete-card';
        del.type = 'button';
        del.setAttribute('data-delete-entry', job.id);
        del.setAttribute('aria-label', 'Delete ' + productName(job) + ' Try-On');
        del.textContent = '×';
        del.addEventListener('click', function (ev) { ev.stopPropagation(); requestDelete(job.id); });
        fig.appendChild(del);
      }
      if (processing) {
        var ov = document.createElement('span');
        ov.className = 'processing-overlay';
        ov.innerHTML = '<i class="spinner" aria-hidden="true"></i><span>Still processing</span>';
        fig.appendChild(ov);
      }
      var content = document.createElement('div');
      content.className = 'try-on-card-content';
      var h3 = document.createElement('h3');
      var h3Link = document.createElement('a');
      h3Link.href = productUrlForJob(job);
      h3Link.textContent = productName(job);
      h3Link.title = productName(job);
      h3.appendChild(h3Link);
      content.appendChild(h3);
      var cartLink = document.createElement('button');
      cartLink.className = 'card-cart';
      cartLink.type = 'button';
      cartLink.textContent = processing ? 'AVAILABLE WHEN READY' : 'ADD TO CART';
      if (processing) cartLink.setAttribute('aria-disabled', 'true');
      cartLink.addEventListener('click', function (ev) { ev.stopPropagation(); if (!processing) handleJobBuy(job, cartLink); });
      if (!processing) {
        var checkStock = function () { refreshJobBuyState(job, cartLink); };
        if (window.requestIdleCallback) window.requestIdleCallback(checkStock, { timeout: 1500 });
        else setTimeout(checkStock, 0);
      }
      content.appendChild(cartLink);
      el.appendChild(fig); el.appendChild(content);
      openBtn.addEventListener('click', function () {
        if (!processing && resultDialog) resultDialog.open(job.id);
      });
      if (!processing && job.resultUrl) {
        var prefetch = function () {
          try {
            var pre = new Image();
            pre.decoding = 'async';
            pre.fetchPriority = 'low';
            pre.src = job.resultUrl;
          } catch (e) {}
        };
        openBtn.addEventListener('mouseenter', prefetch, { once: true });
        openBtn.addEventListener('focus', prefetch, { once: true });
      }
      return el;
    }
    var renderQueued = false;
    var renderTimer = 0;
    function scheduleRenderJobs() {
      if (renderQueued) return;
      renderQueued = true;
      renderTimer = setTimeout(function () { renderQueued = false; renderTimer = 0; renderJobs(); }, 0);
    }
    function renderJobsNow() {
      if (renderTimer) { clearTimeout(renderTimer); renderTimer = 0; }
      renderQueued = false;
      renderJobs();
    }
    function renderJobs() {
      if (!client) return;
      var all = sortNewestFirst(client.list());
      var jobs = all.filter(matches);
      if (librarySection) librarySection.hidden = false;
      var pc = $('[data-mtg="pictureCount"]');
      if (pc) pc.textContent = all.length + ' picture' + (all.length === 1 ? '' : 's');
      grid.innerHTML = '';
      jobs.forEach(function (job, i) {
        var priority = i === 0 ? 'high' : (highlightJob && job.id === highlightJob ? 'auto' : 'low');
        var el = card(job, priority);
        grid.appendChild(el);
      });
      var showEmpty = jobs.length === 0;
      if (empty) {
        empty.hidden = !showEmpty;
        if (showEmpty && !all.length) {
          var link = $('[data-mtg="emptyShopLink"]');
          if (link) link.href = shopAllUrl;
        }
      }
      if (highlightJob && grid.querySelector) {
        var t = grid.querySelector('[data-entry-id="' + highlightJob.replace(/"/g, '') + '"]');
        if (t && t.scrollIntoView) t.scrollIntoView({ block: 'center' });
      }
      renderRecent(all);
      renderRemaining();
    }
    /* 右上角剩余额度：以后端 quota.remainingToday 为准；拿不到才回退 10 */
    function renderRemaining() {
      var rc = $('[data-mtg="remainingCount"]');
      if (!rc) return;
      var n = null;
      try {
        var q = client && typeof client.getQuota === 'function' ? client.getQuota() : null;
        if (q && q.remainingToday != null) n = Math.max(Number(q.remainingToday) || 0, 0);
      } catch (e) {}
      rc.textContent = String(n == null ? '10' : n);
    }
    function renderRecent(all) {
      if (!recentSection) return;
      var holder = $('[data-mtg="recentGrid"]');
      if (!holder) return;
      var seen = {};
      var recents = [];
      all.forEach(function (job) {
        var key = (job.color || '') + '|' + (job.length || '');
        if (!seen[key] && job.skuImageUrl) { seen[key] = 1; recents.push(job); }
      });
      recents = recents.slice(0, 4);
      if (!recents.length) { recentSection.hidden = true; return; }
      recentSection.hidden = false;
      var allLink = $('[data-mtg="recentAllLink"]');
      if (allLink) allLink.href = shopAllUrl;
      holder.innerHTML = '';
      recents.forEach(function (job) {
        var art = document.createElement('article');
        art.className = 'recent-card';
        var img = document.createElement('img');
        img.alt = productName(job);
        img.loading = 'lazy';
        img.decoding = 'async';
        img.fetchPriority = 'low';
        img.width = 110; img.height = 145;
        bindImageFallback(img, imageSourcesFor(job, false), { host: art });
        var div = document.createElement('div');
        var small = document.createElement('small');
        small.textContent = 'TRY-ON AVAILABLE';
        var h3 = document.createElement('h3');
        h3.textContent = productName(job);
        var p = document.createElement('p');
        p.textContent = jobLabel(job);
        var a = document.createElement('a');
        a.textContent = 'VIEW THIS LOOK';
        /* 跳对应 SKU 详情：有 variant 直达 ?variant=，否则产品页（带试戴上下文） */
        (function () {
          var vid = variantOf(job);
          if (job && job.productHandle && vid) a.href = '/products/' + encodeURIComponent(job.productHandle) + '?variant=' + encodeURIComponent(vid);
          else if (job && job.productHandle) a.href = '/products/' + encodeURIComponent(job.productHandle) + '?tryon_job=' + encodeURIComponent(job.id);
          else a.href = shopAllUrl;
        })();
        div.appendChild(small); div.appendChild(h3); div.appendChild(p); div.appendChild(a);
        art.appendChild(img); art.appendChild(div);
        holder.appendChild(art);
      });
    }

    function openSlotDialog() {
      var hasBoth = gallerySlots.front && gallerySlots.side;
      ['front', 'side'].forEach(function (slot) {
        var prev = $('[data-mtg="' + slot + 'SlotPreview"]');
        var st = $('[data-mtg="' + slot + 'SlotStatus"]');
        var url = gallerySlots[slot];
        if (prev) {
          if (url) {
            prev.innerHTML = '';
            var im = document.createElement('img');
            im.alt = 'Saved ' + slot + ' view';
            im.loading = 'lazy';
            im.decoding = 'async';
            im.fetchPriority = 'low';
            im.src = url;
            prev.appendChild(im);
          } else {
            prev.textContent = '＋';
          }
        }
        if (st) st.textContent = gallerySlots[slot] ? 'Saved photo — click to replace' : 'Empty slot';
      });
      var desc = $('[data-mtg="slotDialogDescription"]');
      if (desc) desc.textContent = hasBoth ? 'Both slots are filled. Choose one to replace.' : 'Which view would you like to upload?';
      var dlg = $('[data-mtg="closeSlotDialog"]');
      showDlg(dlg ? dlg.closest('x-modal') : null);
    }
    /* ---- 结果弹窗 ---- */
    function findJob(id) { return client ? client.get(id) : null; }
    function requestDelete(id) {
      var job = findJob(id);
      if (!job) return;
      var t = $('[data-mtg="confirmTitle"]');
      if (t) t.textContent = 'Delete this Try-On?';
      var m = $('[data-mtg="confirmMessage"]');
      if (m) m.textContent = 'This picture will be permanently removed from your gallery.';
      pendingConfirm = function () {
        if (!client) return;
        var job = findJob(id);
        if (job && isProcessing(job)) {
          client.cancel(id).then(function () { showToast('Try-On cancelled.'); renderJobs(); })
            .catch(function () { showToast('Cancel failed, please retry.'); });
        } else {
          client.deleteJob(id).then(function () { showToast('Try-On picture deleted.'); renderJobs(); })
            .catch(function () { showToast('Delete failed, please retry.'); });
        }
      };
      showDlg($('[data-mtg="confirmCancel"]') ? $('[data-mtg="confirmCancel"]').closest('x-modal') : null);
    }

    var resultDialog = window.JalizaTryOnCore && window.JalizaTryOnCore.createResultDialog
      ? window.JalizaTryOnCore.createResultDialog({
          root: root,
          client: client,
          findJob: findJob,
          renderSpecs: function (job, payload) {
            if (!commerce) return false;
            var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';
            commerce.renderSpecRows(payload.container, commerce.jobSpecRows(job, payload.product, payload.variant, { currency: currency }));
            if (isFailed(job)) return;
            commerce.resolveJobAdd(job, {
              kind: job.kind,
              productType: job.productType,
              product: payload.product,
              variant: payload.variant,
              fresh: true
            }).then(function (action) {
              var cacheKey = String(job.id || job.variantId || '');
              if (cacheKey) {
                jobAvailability[cacheKey] = Promise.resolve(action);
                var cardBtn = jobCardBuyButton(job);
                if (cardBtn) refreshJobBuyState(job, cardBtn);
              }
              var cart = payload.cart;
              if (!cart) return;
              if (action.mode === 'sold_out') { cart.disabled = true; cart.textContent = 'SOLD OUT'; }
              else if (action.mode === 'unavailable') { cart.disabled = true; cart.textContent = 'UNAVAILABLE'; }
              else { cart.disabled = false; cart.textContent = action.mode === 'cap' ? 'CHOOSE CAP SIZE' : 'ADD TO CART'; }
            }).catch(function () {});
            return true;
          },
          onCart: handleJobBuy,
          toast: showToast,
          canOpen: function (job) { return !isProcessing(job); },
          failedCopy: function (job) {
            if (!isFailed(job)) return null;
            return {
              cart: (job.retryCount || 0) >= 2
                ? 'RETRY LIMIT REACHED'
                : '↻ RETRY THIS TRY-ON',
              regenerateHidden: true
            };
          },
          onRetry: function (job, btn) {
            if (!isFailed(job)) return false;
            if ((job.retryCount || 0) >= 2) {
              showToast('Retry limit reached.');
              return true;
            }
            if (btn) btn.disabled = true;
            client.retry(job.id).then(function (newJob) {
              resultDialog.close();
              showToast("Retrying your Try-On — we'll email you when it's ready.");
              var nid = (newJob && newJob.id) || job.id;
              highlightJob = nid;
              client.ensureSubscribed(nid);
              renderJobs();
            }).catch(function (e) {
              var qm = client && typeof client.quotaErrorMessage === 'function'
                ? client.quotaErrorMessage(e) : null;
              showToast(qm || 'Retry failed, please try again later.');
            }).then(function () { if (btn) btn.disabled = false; });
            return true;
          },
          confirmDelete: function (job) {
            resultDialog.close();
            requestDelete(job.id);
            return true;
          },
          afterDelete: function () { renderJobs(); },
          afterRegenerate: function (id) {
            highlightJob = id;
            renderJobs();
          }
        })
      : null;

    /* ---- 事件绑定 ---- */
    $$('[data-mtg-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeFilter = btn.getAttribute('data-mtg-filter');
        $$('[data-mtg-filter]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        renderJobs();
      });
    });
    var fileInput = $('[data-mtg="sourcePhotoInput"]');
    var addBtn = $('[data-mtg="addSourcePhoto"]');
    if (addBtn) addBtn.addEventListener('click', function () { openSlotDialog(); });
    $$('[data-mtg-select-slot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pendingSlot = btn.getAttribute('data-mtg-select-slot') === 'side' ? 'side' : 'front';
        var dlg = $('[data-mtg="closeSlotDialog"]');
        hideDlg(dlg ? dlg.closest('x-modal') : null);
        if (fileInput) fileInput.click();
      });
    });
    var closeSlot = $('[data-mtg="closeSlotDialog"]');
    if (closeSlot) closeSlot.addEventListener('click', function () { hideDlg(closeSlot.closest('x-modal')); });
    if (fileInput) fileInput.addEventListener('change', function (ev) {
      var f = ev.target.files && ev.target.files[0];
      ev.target.value = '';
      if (f) uploadGalleryFile(f);
    });
    var consent = $('[data-mtg="photoConsent"]');
    var useBtn = $('[data-mtg="useSelectedPhoto"]');
    if (consent && useBtn) consent.addEventListener('change', function () { useBtn.disabled = !consent.checked; });
    if (useBtn) useBtn.addEventListener('click', function () {
      if (!requireLogin()) return;
      if (!pendingPhotoFile || !(consent && consent.checked)) return;
      useBtn.disabled = true;
      useBtn.textContent = 'UPLOADING…';
      client.uploadSourcePhoto(pendingPhotoFile, pendingSlot).then(function (saved) {
        if (saved && saved.url) gallerySlots[pendingSlot] = saved.url;
        renderGallerySlots();
        pendingPhotoFile = null;
        var closeBtn = $('[data-mtg="closeUploadReview"]');
        hideDlg(closeBtn ? closeBtn.closest('x-modal') : null);
        var label = pendingSlot === 'side' ? 'Side' : 'Front';
        showToast(label + ' photo saved. Choose it when you start your next Try-On.', 4200);
      }).catch(function () {
        showToast('Upload failed, please retry.');
      }).then(function () {
        useBtn.disabled = false;
        useBtn.textContent = 'USE THIS PHOTO';
      });
    });
    var closeUp = $('[data-mtg="closeUploadReview"]');
    if (closeUp) closeUp.addEventListener('click', function () { hideDlg(closeUp.closest('x-modal')); });
    var diffBtn = $('[data-mtg="chooseDifferentPhoto"]');
    if (diffBtn && fileInput) diffBtn.addEventListener('click', function () {
      var closeBtn = $('[data-mtg="closeUploadReview"]');
      hideDlg(closeBtn ? closeBtn.closest('x-modal') : null);
      fileInput.click();
    });
    var cancelBtn = $('[data-mtg="confirmCancel"]');
    if (cancelBtn) cancelBtn.addEventListener('click', function () { hideDlg(cancelBtn.closest('x-modal')); pendingConfirm = null; });
    var okBtn = $('[data-mtg="confirmAction"]');
    if (okBtn) okBtn.addEventListener('click', function () {
      hideDlg(okBtn.closest('x-modal'));
      if (typeof pendingConfirm === 'function') { try { pendingConfirm(); } catch (e) {} }
      pendingConfirm = null;
    });

    /* ---- 启动：未登录只看门禁，不调任何后端（不拉 jobs/不拉 source photo、不给上传入口） ---- */
    if (!loggedIn) {
      if (loading) loading.hidden = true;
      if (gate) gate.hidden = false;
      if (loginLink) loginLink.href = loginUrl;
      if (sourceCard) sourceCard.hidden = true;
      if (librarySection) librarySection.hidden = true;
      if (recentSection) recentSection.hidden = true;
      return;
    }
    if (!client) {
      if (loading) loading.hidden = true;
      if (errorBox) { errorBox.hidden = false; errorBox.textContent = 'Gallery is unavailable right now.'; }
      return;
    }
    client.onChange(function (change) { if (change && change.job) scheduleRenderJobs(); });
    /* 后端 quota 回来（或变化）时刷新剩余额度 */
    try { if (client && typeof client.onQuota === 'function') client.onQuota(function () { renderRemaining(); }); } catch (e) {}
    loadSource();
    client.fetchHistory('__all__', 'all').then(function () {
      if (loading) loading.hidden = true;
      renderJobsNow();
      client.ensureSubscribed();
    }).catch(function () {
      if (loading) loading.hidden = true;
      if (errorBox) { errorBox.hidden = false; errorBox.textContent = 'Could not load your previews. Please refresh and try again.'; }
    });
  }
  document.querySelectorAll('[data-my-try-on-gallery]').forEach(init);
})();
